import { createContext, useContext, type ReactNode } from 'react';

const PaletteContext = createContext<string[]>([]);

interface PaletteProviderProps {
  colors: string[];
  children: ReactNode;
}

export const PaletteProvider = ({ colors, children }: PaletteProviderProps) => (
  <PaletteContext.Provider value={colors}>{children}</PaletteContext.Provider>
);

export const usePaletteColors = (): string[] => useContext(PaletteContext);
